import { Box, Flex, Image, Text } from "@chakra-ui/react";
import ArrowRight from "@root/assets/icons/right-arrow.svg";
import PlusIcon from "@root/assets/icons/plusicon";
import { useMainChatContext } from "@root/context/kps-chat-context";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import {
  getThreadLoading,
  getThreadList,
} from "@root/store/selectors/entities/thread";
import { useMemo } from "react";
import { CHAT_STATUS_GENERAL } from "@root/constants/chatStatus";

const ChatFollowUpQuestions = ({ followUpQuestions = [] }: any) => {
  const {
    setInput,
    submitHandler,
    currentMessageResponse,
    isMessaging,
    isTypewriterActive,
  } = useMainChatContext();
  const { t } = useTranslation("common");
  const threadLoading = useSelector(getThreadLoading);
  const threadList = useSelector(getThreadList);

  // Check if answer is currently being generated
  const isGeneratingAnswer = useMemo(() => {
    // Check thread loading state
    if (threadLoading) return true;

    // Check isMessaging flag
    if (isMessaging) return true;

    // Check if typewriter effect is active (still typing)
    if (isTypewriterActive) return true;

    // Check currentMessageResponse status
    if (currentMessageResponse?.status !== undefined) {
      const status = currentMessageResponse?.status;
      return CHAT_STATUS_GENERAL?.PROCESSING?.includes(status);
    }

    // Check if last message in threadList is still processing
    if (Array.isArray(threadList) && threadList?.length > 0) {
      const lastMessage: any = threadList?.[threadList?.length - 1];
      if (
        lastMessage &&
        typeof lastMessage === "object" &&
        lastMessage?.meta &&
        lastMessage?.meta?.status !== undefined
      ) {
        const status = lastMessage?.meta?.status;
        return CHAT_STATUS_GENERAL?.PROCESSING?.includes(status);
      }
    }

    return false;
  }, [
    threadLoading,
    isMessaging,
    isTypewriterActive,
    currentMessageResponse,
    threadList,
  ]);

  const handleClick = (question: string) => {
    if (!question || isGeneratingAnswer) return;
    submitHandler(question, true);
  };

  return (
    <Box>
      <Text fontWeight={700} fontSize="20px" color="#0F172A" mb="12px">
        {t("translate.followUps")}:
      </Text>
      <Flex direction="column" gap="10px">
        {followUpQuestions?.map((q: any, idx: number) => {
          return (
            <Flex
              key={`${idx}-${q}`}
              // border="1px solid #E2E8F0"
              borderRadius="8px"
              py="2px"
              alignItems="center"
              justifyContent="space-between"
              cursor={isGeneratingAnswer ? "not-allowed" : "pointer"}
              // _hover={
              //   isGeneratingAnswer
              //     ? {}
              //     : { borderColor: "#40599B", bg: "#F5F7FF" }
              // }
              transition="all 0.2s"
              onClick={() => handleClick(q)}
              opacity={isGeneratingAnswer ? 0.5 : 1}
              pointerEvents={isGeneratingAnswer ? "none" : "auto"}
            >
              <Text fontSize="15px" fontWeight="500" color="#404040">
                {q}
              </Text>
              <PlusIcon color="#111827" />
            </Flex>
          );
        })}
      </Flex>
    </Box>
  );
};

export default ChatFollowUpQuestions;
